import { getClaimsOrdersOrderIdClaims } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const CLAIM_BY_ORDER_ID = "CLAIM_BY_ORDER_ID";

export function useGetClaimsByOrderIdQuery(orderId?: number) {
	return useQuery({
		queryKey: [CLAIM_BY_ORDER_ID, orderId],
		queryFn: processResponse(() => getClaimsOrdersOrderIdClaims(orderId!)),
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId,
	});
}
